<div class="lside">
  <img src="./../../../assets/images/SVG/logo_ai.svg">
</div>

<div *ngIf="analysis as a" class="dashboard">
  <section class="panel export-meta" *ngIf="exportHeader">
    <div class="panel-header compact">
      <div>
        <h3>{{ 'analisis_replay_contexto_exportacion' | translate }}</h3>
      </div>
    </div>

    <div class="export-meta-grid">
      <div class="export-meta-item">
        <span class="summary-title">{{ 'codigo_replay' | translate }}</span>
        <strong>{{ exportHeader.replayCode || ('analisis_replay_sin_datos_corto' | translate) }}</strong>
      </div>

      <div class="export-meta-item">
        <span class="summary-title">{{ 'usuario' | translate }}</span>
        <strong>{{ exportHeader.userName || ('analisis_replay_sin_datos_corto' | translate) }}</strong>
      </div>

      <div class="export-meta-item">
        <span class="summary-title">{{ 'ejercicio' | translate }}</span>
        <strong>{{ exportHeader.exerciseName || ('analisis_replay_sin_datos_corto' | translate) }}</strong>
      </div>

      <div class="export-meta-item">
        <span class="summary-title">{{ 'fecha' | translate }}</span>
        <strong>{{ exportHeader.date || ('analisis_replay_sin_datos_corto' | translate) }}</strong>
      </div>

      <div class="export-meta-item">
        <span class="summary-title">{{ 'hora' | translate }}</span>
        <strong>{{ exportHeader.time || ('analisis_replay_sin_datos_corto' | translate) }}</strong>
      </div>
    </div>
  </section>

  <section class="hero">
    <div class="hero-copy">
      <h2>{{ 'analisis_replay_informe_evaluacion' | translate }}</h2>
      <p class="hero-summary">{{ executiveSummary }}</p>

      <div class="hero-tags" *ngIf="a.issues?.length">
        <span class="tag tag-soft">{{ a.issues.length }} {{ 'analisis_replay_incidencias' | translate }}</span>
      </div>
    </div>

    <div class="hero-score">
      <span class="hero-score-label">{{ 'puntuacion' | translate }}</span>
      <strong class="hero-score-value">
        <span>{{ exerciseScore ?? ('analisis_replay_sin_datos_corto' | translate) }}</span><span class="hero-score-unit" *ngIf="exerciseScore != null">%</span>
      </strong>
    </div>
  </section>

  <section class="summary-grid">
    <article class="summary-card">
      <span class="summary-title">{{ 'analisis_replay_fortalezas' | translate }}</span>
      <strong class="summary-number">{{ totalStrengths }}</strong>
      <p class="summary-description">{{ 'analisis_replay_fortalezas_descripcion' | translate }}</p>
    </article>

    <article class="summary-card">
      <span class="summary-title">{{ 'analisis_replay_errores_graves' | translate }}</span>
      <strong class="summary-number">{{ criticalErrorsCount }}</strong>
      <p class="summary-description">{{ 'analisis_replay_errores_graves_descripcion' | translate }}</p>
    </article>

    <article class="summary-card">
      <span class="summary-title">{{ 'analisis_replay_areas_mejora' | translate }}</span>
      <strong class="summary-number">{{ totalImprovements }}</strong>
      <p class="summary-description">{{ 'analisis_replay_areas_mejora_descripcion' | translate }}</p>
    </article>
  </section>

  <section class="analysis-grid">
    <article class="panel panel-highlight">
      <div class="panel-header">
        <div>
          <h3>{{ 'analisis_replay_resumen_global' | translate }}</h3>
          <p>{{ a.summary.overall_assessment }}</p>
        </div>
      </div>

      <div class="checks-list" *ngIf="a.final_result_quality.criteria_checks?.length">
        <div class="check-item" *ngFor="let check of a.final_result_quality.criteria_checks">
          <div class="check-header">
            <strong>{{ check.criterion }}</strong>
            <span [ngClass]="check.met ? 'ok-badge state-positive' : 'bad-badge state-negative'">
              {{ (check.met ? 'analisis_replay_cumple' : 'analisis_replay_no_cumple') | translate }}
            </span>
          </div>
          <div
            class="check-body"
            *ngIf="check.assessment">
            {{ getAssessmentLabel(check.assessment) | uppercase }}
          </div>
        </div>
      </div>
    </article>

    <article class="panel panel-chart">
      <div class="panel-header">
        <div>
          <h3>{{ 'analisis_replay_radar_desempeno' | translate }}</h3>
        </div>
      </div>

      <div class="chart-wrapper">
        <canvas
          baseChart
          [type]="radarChartType"
          [data]="decorativeRadarData"
          [options]="decorativeRadarOptions">
        </canvas>
      </div>

      <p class="chart-note">
        {{ 'analisis_replay_nota_radar' | translate }}
      </p>
    </article>
  </section>

  <section class="panel explanation-card" *ngIf="a.explanation">
    <div class="panel-header">
      <div>
        <h3>{{ 'analisis_replay_evaluacion_desempeno' | translate }}</h3>
      </div>
    </div>

    <div class="explanation-html" [innerHTML]="safeExplanation"></div>
  </section>

  <section class="section-header">
    <div>
      <h3>{{ 'analisis_replay_capacidades_observadas' | translate }}</h3>
    </div>
  </section>

  <div class="technical-grid">
    <div class="panel metric-card">
      <div class="metric-header">
        <strong>{{ 'analisis_replay_control_instrumental' | translate }}</strong>
        <span class="metric-assessment" [ngClass]="getAssessmentToneClass(a.technical_performance.instrument_handling.assessment)">
          {{ getAssessmentLabel(a.technical_performance.instrument_handling.assessment) | uppercase }}
        </span>
      </div>
      <ul class="bullet-list">
        <li *ngFor="let item of a.technical_performance.instrument_handling.findings">{{ item }}</li>
      </ul>
    </div>

    <div class="panel metric-card">
      <div class="metric-header">
        <strong>{{ 'analisis_replay_precision' | translate }}</strong>
        <span class="metric-assessment" [ngClass]="getAssessmentToneClass(a.technical_performance.precision.assessment)">
          {{ getAssessmentLabel(a.technical_performance.precision.assessment) | uppercase }}
        </span>
      </div>
      <ul class="bullet-list">
        <li *ngFor="let item of a.technical_performance.precision.findings">{{ item }}</li>
      </ul>
    </div>

    <div class="panel metric-card">
      <div class="metric-header">
        <strong>{{ 'analisis_replay_eficiencia_movimiento' | translate }}</strong>
        <span class="metric-assessment" [ngClass]="getAssessmentToneClass(a.technical_performance.movement_efficiency.assessment)">
          {{ getAssessmentLabel(a.technical_performance.movement_efficiency.assessment) | uppercase }}
        </span>
      </div>
      <ul class="bullet-list">
        <li *ngFor="let item of a.technical_performance.movement_efficiency.findings">{{ item }}</li>
      </ul>
    </div>

    <div class="panel metric-card">
      <div class="metric-header">
        <strong>{{ 'analisis_replay_coordinacion_bimanual' | translate }}</strong>
        <span class="metric-assessment" [ngClass]="getAssessmentToneClass(a.technical_performance.bimanual_coordination.assessment)">
          {{ getAssessmentLabel(a.technical_performance.bimanual_coordination.assessment) | uppercase }}
        </span>
      </div>
      <ul class="bullet-list">
        <li *ngFor="let item of a.technical_performance.bimanual_coordination.findings">{{ item }}</li>
      </ul>
    </div>

    <div class="panel metric-card">
      <div class="metric-header">
        <strong>{{ 'analisis_replay_seguridad_tarea' | translate }}</strong>
        <span class="metric-assessment" [ngClass]="getAssessmentToneClass(a.technical_performance.task_safety.assessment)">
          {{ getAssessmentLabel(a.technical_performance.task_safety.assessment) | uppercase }}
        </span>
      </div>
      <ul class="bullet-list">
        <li *ngFor="let item of a.technical_performance.task_safety.findings">{{ item }}</li>
      </ul>
    </div>

    <div class="panel metric-card">
      <div class="metric-header">
        <strong>{{ 'analisis_replay_gestion_campo_visual' | translate }}</strong>
        <span class="metric-assessment" [ngClass]="getAssessmentToneClass(a.technical_performance.visual_field_management.assessment)">
          {{ getAssessmentLabel(a.technical_performance.visual_field_management.assessment) | uppercase }}
        </span>
      </div>
      <ul class="bullet-list">
        <li *ngFor="let item of a.technical_performance.visual_field_management.findings">{{ item }}</li>
      </ul>
    </div>
  </div>

  <section class="insights-group">
    <section class="panel panel-strengths" *ngIf="a.strengths?.length">
      <div class="panel-header compact">
        <div>
          <h3>{{ 'analisis_replay_fortalezas' | translate }}</h3>
        </div>
      </div>

      <ul class="bullet-list bullet-list-spaced">
        <li *ngFor="let s of a.strengths">{{ s }}</li>
      </ul>
    </section>

    <div class="detail-grid" *ngIf="a.errors_detected?.length || a.areas_for_improvement?.length">
      <div class="panel">
        <div class="panel-header compact">
          <div>
            <h3>{{ 'analisis_replay_errores_detectados' | translate }}</h3>
          </div>
        </div>

        <ng-container *ngIf="a.errors_detected?.length; else noErrorsDetected">
          <div class="error-item" *ngFor="let e of a.errors_detected">
            <div class="error-header">
              <strong>{{ e.type }}</strong>
              <span class="severity" [ngClass]="e.severity">{{ getSeverityLabel(e.severity) }}</span>
            </div>
            <div class="detail-copy">{{ e.description }}</div>
          </div>
        </ng-container>

        <ng-template #noErrorsDetected>
          <div class="error-item detail-empty">
            {{ 'analisis_replay_sin_errores_detectados' | translate }}
          </div>
        </ng-template>
      </div>

      <div class="panel">
        <div class="panel-header compact">
          <div>
            <h3>{{ 'analisis_replay_areas_mejora' | translate }}</h3>
          </div>
        </div>

        <ng-container *ngIf="a.areas_for_improvement?.length; else noImprovements">
          <div class="improvement-item" *ngFor="let item of a.areas_for_improvement">
            <div class="improvement-header">
              <strong>{{ item.topic }}</strong>
              <span class="priority" [ngClass]="item.priority">{{ getPriorityLabel(item.priority) }}</span>
            </div>
            <div class="detail-copy">{{ item.recommendation }}</div>
          </div>
        </ng-container>

        <ng-template #noImprovements>
          <div class="improvement-item detail-empty">
            {{ 'analisis_replay_sin_areas_mejora_adicionales' | translate }}
          </div>
        </ng-template>
      </div>
    </div>
  </section>

  <section class="panel" *ngIf="a.issues?.length">
    <div class="panel-header compact">
      <div>
        <h3>{{ 'analisis_replay_incidencias' | translate }}</h3>
      </div>
    </div>

    <ul class="bullet-list bullet-list-spaced">
      <li *ngFor="let issue of a.issues">{{ issue }}</li>
    </ul>
  </section>
</div>

<div class="rside">
  <img src="./../../../assets/images/SVG/ia_stars_color.svg">
</div>
